var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = !_vm.loading ? _vm.theme() || "" : null
  var m1 = !_vm.loading ? _vm.theme() : null
  var g0 = !_vm.loading ? _vm.reward.length > 0 && _vm.reward[0] >= 1 : null
  var m2 = !_vm.loading && g0 ? _vm.points_name() : null
  var g1 = !_vm.loading
    ? _vm.reward.length > 0 && _vm.reward[0] == 1 && !_vm.is_sign
    : null
  var l0 = !_vm.loading
    ? _vm.__map(_vm.daylist, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var g2 = _vm.list.indexOf(item.day) > -1 && item.type == 0
        var g3 = _vm.list.indexOf(item.day)
        var g4 =
          g3 == -1
            ? _vm.reward.indexOf(item.day - _vm.today) > -1 && item.type == 0
            : null
        var g5 =
          g3 == -1
            ? item.type == 0 && _vm.reward.indexOf(item.day - _vm.today) == -1
            : null
        return {
          $orig: $orig,
          g2: g2,
          g3: g3,
          g4: g4,
          g5: g5,
        }
      })
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        g0: g0,
        m2: m2,
        g1: g1,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }